import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { getOffersListApiRequest } from '@/services/api/offers-api';
import { getLandingsListApiRequest } from '@/services/api/landings-api';
import { useStore } from '@/store';

type FlowSelectForm = {
  workspaceId: string;
  countryId?: string;
};

export const useCampaignFlowSelectOptions = (form: MaybeRefOrGetter<FlowSelectForm>) => {
  const store = useStore();
  const fetchOfferOptions = computed(() => {
    const formValue = toValue(form);
    const { countryId } = formValue;

    if (store.cache.offers.isAllInCache) {
      return;
    }

    return ({ search }: { search: string }) =>
      getOffersListApiRequest({
        search,
        status: 'active',
        limit: '200',
        orderBy: 'updated',
        ...(countryId && { countryId }),
        orderDirection: 'desc',
        columns: [
          'id',
          'name',
          'nameFull',
          'countryId',
          'affiliateNetworkId',
          'affiliateNetworkName',
          'countryName',
          'url',
        ],
        workspaceId: formValue.workspaceId,
      });
  });

  const fetchLandingOptions = computed(() => {
    const formValue = toValue(form);
    const { countryId } = formValue;

    if (store.cache.landings.isAllInCache) {
      return;
    }

    return ({ search }: { search: string }) =>
      getLandingsListApiRequest({
        search,
        status: 'active',
        ...(countryId && { countryId }),
        limit: '200',
        orderBy: 'updated',
        orderDirection: 'desc',
        columns: ['id', 'name', 'nameFull', 'countryId', 'offers', 'url'],
        tagsOff: 1,
        workspaceId: formValue.workspaceId,
      });
  });

  return {
    fetchOfferOptions,
    fetchLandingOptions,
  };
};
